import { createFileRoute } from '@tanstack/react-router';
import LibraryMediaPage from 'src/Media/LibraryMediaPage';
import { requireAuth } from 'src/utils/authGuard';
import { z } from 'zod';

// Search params schema for media page - includes context about where we came from
const mediaPageSearchSchema = z.object({
  // Collection context - replaces location.state
  collectionId: z.string().optional(),
  collectionType: z.enum(['GALLERY', 'PLAYLIST']).optional(),
  // View context
  fromLibrary: z.boolean().default(true),
});

export type MediaPageSearchParams = z.infer<typeof mediaPageSearchSchema>;

export const Route = createFileRoute('/library/media-page/$clipId')({
  validateSearch: mediaPageSearchSchema,
  beforeLoad: () => {
    requireAuth();
  },
  component: LibraryMediaPage,
});
